export default __webpack_public_path__ + "static/media/icon-big-pack-88-px.630310d0.svg";